/*eslint-disable array-callback-return */
/*eslint-disable linebreak-style */
/*eslint-disable eqeqeq */
/*eslint-disable no-redeclare */
/*eslint-disable no-unused-vars */
import React, { useState, useEffect, useCallback } from 'react';
import { Navigate } from 'react-router-dom';
import { Row, Col, Tab, Nav, Container } from 'react-bootstrap';
import AllMemberDetailsInfo from './AllMemberDetailsInfo';
import NoDataFound from '../common/NoDataFound';
import MemberList from '../../api/MemberList';
import APIEndpoints from '../../api/APIEndpoints';
import RetryAPI from '../../api/RetryAPI';
import HttpErrorHandler from '../../errorhandling/HttpErrorHandler';
import {
  HttpErrorCodes,
  HttpSuccessCodes,
} from '../../errorhandling/HttpErrorCodes';
import './member.scss';
import { axiosInstance } from '../../../api/axios';
import MemberManageSkeleton from './Skeleton/MemberManageSkeleton';
import AllMemberSkeleton from './Skeleton/AllMemberSkeleton';
import {
  CustomPagination,
  CustomPaginationItemsDisplay,
} from 'src/Admin/components/common/CustomPagination';
import { capitalizeFirstLetter } from '../../utils/strings';
import CustomClientError from '../../errorhandling/CustomClientError';
import MasterPermissions from '../../api/MasterPermissions';

const cacheBuster = (url) => `${url}?cb=${Date.now()}`;

const AllMember = (props) => {
  const [memberListData, setMemberListData] = useState('');
  const [loadingPage, setLoadingPage] = useState(true);
  const [loadingMemberList, setLoadingMemberList] = useState(true);
  const [serverError, setServerError] = useState(false);
  const [clientError, setClientError] = useState(false);
  const [userIndex, setUserIndex] = useState(0);
  const [userEmail, setUserEmail] = useState('');
  const [searchText, setSearchText] = useState(props.searchText);
  const [searchTextBox, setSearchTextBox] = useState('');
  const [memberSearchList, setMemberSearchList] = useState();
  //const [ activePage, setActivePage ] = useState( 1 );
  const [selectedPageCnt, setSelectPageCnt] = useState(10);
  const [itemsPerPageStart, setItemsPerPageStart] = useState(1);
  const [selectedRadioBtn, setSelectedRadioBtn] = useState('allMembers');
  const [registered, setRegistered] = useState(true);
  const [totalItemsCount, setTotalItemsCount] = useState(0);
  const [isNotFound, setIsNotFound] = useState(false);
  const [isAPIFailed, setIsAPIFailed] = useState(false);
  const [preservePageNumber, setPreservePageNumber] = useState(true);
  const [preservePageSize, setPreservePageSize] = useState(true);
  const [preserveSelectedIndex, setPreserveSelectedIndex] = useState(true);
  const [activePage, setActivePage] = useState(
    preservePageSize
      ? props?.selectedInfo?.activePage && !props?.selectedInfo?.isRegistered
        ? props?.selectedInfo?.activePage
        : 1
      : 1,
  );
  const [pageSize, setPageSize] = useState(
    preservePageNumber
      ? props?.selectedInfo?.pageSize && !props?.selectedInfo?.isRegistered
        ? props?.selectedInfo?.pageSize
        : 10
      : 10,
  );
  const [itemsPerPageEnd, setItemsPerPageEnd] = useState(pageSize);
  const MemberListData = '';
  const SearchMemberListData = '';
  const MemberListResponse = null;
  const MemberListDataResp = null;
  const SearchMemberListResponse = null;
  let SearchMemberListDataResp = null;
  let SearchList;
  let SearchValue;
  const MemberListCntResponse = null;
  const MemberListCntDataResp = null;
  const EncrptedCntResp = null;
  let source;
  const displayPaginationMininumCount = 10;

  //Preserve State
  useEffect(() => {
    if (props.selectedInfo != undefined && !props?.selectedInfo?.isRegistered) {
      if (preservePageSize && pageSize != props.selectedInfo.pageSize) {
        setPageSize(props.selectedInfo.pageSize);
      }
      if (preservePageNumber && activePage != props.selectedInfo.activePage) {
        setActivePage(props.selectedInfo.activePage);
      }
      if (memberListData?.MemberOrDependent?.length > 0) {
        if (preserveSelectedIndex) {
          if (
            preservePageNumber &&
            memberListData?.Pagination?.PageNumber ==
              props.selectedInfo.activePage
          ) {
            selectingUserDynamically(
              props.selectedInfo.userIndex,
              memberListData,
            );
          }
        } else {
          selectingUserDynamically(0, memberListData);
        }
      }
    }
  }, [props.selectedInfo, memberListData]);
  //Preserve State

  //Preserving State
  useEffect(() => {
    if (props.putDataInitialState && preservePageNumber && preservePageSize) {
      setPreserveSelectedIndex(false);
      setPreservePageNumber(false);
      setPreservePageSize(false);
      setActivePage(1);
      if (props.resetPageSize) {
        setPageSize(10);
      }

      if (memberListData?.length > 0) {
        selectingUserDynamically(0, memberListData);
      }
    }
  }, [props.putDataInitialState, memberListData]);

  useEffect(() => {
    const { bob, employer, location } = props;

    const globalFilter = () => {
      let strFilter = '';
      if (bob && bob !== 'all') {
        strFilter += `/blkofbusoid/${bob}`;
      }
      if (employer && employer !== 'all') {
        strFilter += `/clientoid/${employer}`;
      }
      if (location && location !== 'all') {
        strFilter += `/locationoid/${location}`;
      }
      return strFilter;
    };

    const advanceSearchFilter = () => {
      let strParams = '';
      const {
        MemberType,
        MemberID,
        DOB,
        FirstName,
        LastName,
        EmailID,
        ContactNumber,
        SSN,
      } = props.additionalSearchValues;

      if (MemberType && MemberType !== 'Both') {
        //const memberTypeVal =
        //memberTypeValue.charAt(0).toUpperCase() + memberTypeValue.slice(1);
        strParams += `membertype/${MemberType}/`;
      }
      if (
        MemberID &&
        (MasterPermissions.CheckPermission('Member ID') ||
          MasterPermissions.CheckPermission('Cert Number'))
      ) {
        strParams += `certificatenumber/${MemberID}/`;
      }
      if (MemberID && MasterPermissions.CheckPermission('Alt ID 1')) {
        strParams += `alternateid1/${MemberID}/`;
      }
      if (MemberID && MasterPermissions.CheckPermission('Alt ID 2')) {
        strParams += `alternateid2/${MemberID}/`;
      }
      if (DOB) {
        strParams += `dateofbirth/${DOB}/`;
      }
      if (FirstName) {
        strParams += `firstname/${FirstName}/`;
      }
      if (LastName) {
        strParams += `lastname/${LastName}/`;
      }
      if (EmailID) {
        strParams += `email/${EmailID}/`;
      }
      if (ContactNumber) {
        strParams += `phone/${ContactNumber}/`;
      }
      if (SSN) {
        strParams += `ssn/${SSN}/`;
      }
      return strParams;
    };

    const searchMemberList = async (setInitialUser = true) => {
      let SearchMemberListAPI = '';
      SearchMemberListAPI = '';
      let apiURL;
      RetryAPI.setResponseReceived(false);
      RetryAPI.resetRetryCount();
      while (RetryAPI.performRetry()) {
        try {
          let strSearchText = '';
          if (props.searchText) {
            strSearchText = `searchkey/${props.searchText}/`;
          }
          apiURL = props.isAdditionalSearch
            ? APIEndpoints.advanceMemberSearch() + advanceSearchFilter()
            : APIEndpoints.getAllMemberListResources() + strSearchText;
          const SearchMemberListResponse = await axiosInstance.get(
            cacheBuster(
              apiURL +
                'PageSize/' +
                pageSize +
                '/PageNumber/' +
                activePage +
                globalFilter(),
            ),
          );

          SearchMemberListDataResp = SearchMemberListResponse.data;
          //memberSearchApiRecursive(APIEndpoints.getAllMemberListResources()
          //+ strSearchText + 'PageSize/' + pageSize + '/PageNumber/' + activePage + globalFilter());
          if (
            SearchMemberListResponse.status ==
            HttpSuccessCodes.HTTP_SUCCESS_CODE_200 //&&
            //props.selectedSearchTypeRadioBtn === 'primarySearch'
          ) {
            setLoadingPage(false);
            setClientError(false);
            console.log(SearchMemberListDataResp, 'SearchMemberListDataResp');
            MemberList.setMemberListResp(SearchMemberListDataResp);
            RetryAPI.resetRetryCount();
            RetryAPI.setResponseReceived(true);
            console.log('Successful Search memberListData: ', memberListData);
            console.log(
              'Successful SearchMemberListResponse: ',
              SearchMemberListDataResp.Response,
            );
            setMemberListData(SearchMemberListDataResp.Response);
            MemberList.setTotalRecords(
              SearchMemberListDataResp.Response.Pagination.TotalRecords,
            );
            setTotalItemsCount(
              SearchMemberListDataResp.Response.Pagination.TotalRecords,
            );
            if (
              SearchMemberListDataResp.Response.MemberOrDependent &&
              SearchMemberListDataResp.Response.MemberOrDependent?.length > 0
            ) {
              console.log('Successful Search memberListData: ', memberListData);
              if (setInitialUser) {
                MemberList.setSelectedUser(
                  SearchMemberListDataResp.Response.MemberOrDependent[0],
                );
                MemberList.setFirstUser(
                  SearchMemberListDataResp.Response.MemberOrDependent[0],
                );
              }
              const start =
                pageSize * (activePage - 1) +
                (MemberList.getTotalRecords ? 1 : 0);
              let end = start + pageSize - 1;
              if (end > MemberList.getTotalRecords()) {
                end = MemberList.getTotalRecords();
              }
              setItemsPerPageStart(start);
              setItemsPerPageEnd(end);
            } else {
              setTotalItemsCount(0);
              MemberList.setSelectedUser(null);
            }
          } else {
            RetryAPI.incrementRetryCount();
            RetryAPI.setResponseReceived(false);
            RetryAPI.setErrorCode(SearchMemberListResponse.status);
            console.log(
              'Search User List Error code:',
              SearchMemberListResponse.status,
            );
          }
          setIsNotFound(false);
          if (RetryAPI.getResponseReceived()) break;
        } catch (error) {
          let errorMessage = '';
          setIsAPIFailed(true);
          if (error.toString().includes('404')) {
            setIsNotFound(true);
          }

          if (error) {
            errorMessage = error.toString();
            //requestAborted = errorMessage.match(/aborted/i);
            RetryAPI.setErrorCode(HttpErrorCodes.HTTP_REQUEST_ABORTED);
          }
          if (error.response) {
            RetryAPI.setErrorCode(error.response.status);
          }

          //if (axios.isCancel(error)) {
          //console.log('Request canceled', error.message);
          //} else {
          //console.log('cancel error');
          //}

          RetryAPI.incrementRetryCount();
          RetryAPI.setResponseReceived(false);
        }
      }

      if (RetryAPI.retryFailed()) {
        const errorCode = RetryAPI.getErrorCode();
        HttpErrorHandler.DisplayServerErrorMessage(errorCode, '');
        setTotalItemsCount(0);

        //Process Client Errors
        if (
          HttpErrorHandler.ProcessedClientErrors(
            errorCode,
            'view Member lists. ',
          )
        ) {
          //Display Error Message -No claims submitted in the past six months.
          setClientError(true);
          setLoadingPage(false);
          setLoadingMemberList(false);
        } else {
          //Handle Excpetion
          if (
            HttpErrorHandler.ProcessedException(
              errorCode,
              'We are unable to render your Member List now.',
            )
          ) {
            setServerError(true);
          }
        }
      } else {
        setLoadingPage(false);
        setLoadingMemberList(false);
      }
    };

    setLoadingMemberList(true);
    setLoadingPage(true);
    setIsAPIFailed(false);
    if (
      props.selectedInfo != undefined &&
      !props?.selectedInfo?.isRegistered &&
      preservePageNumber &&
      preservePageSize
    ) {
      if (
        activePage == props.selectedInfo.activePage &&
        pageSize == props.selectedInfo.pageSize
      ) {
        searchMemberList(false);
      }
    } else {
      searchMemberList();
    }

    setUserIndex(0);
  }, [
    props.searchText,
    activePage,
    pageSize,
    props.bob,
    props.employer,
    props.location,
    props.additionalSearchValues,
  ]);

  //const  memberSearchApiRecursive = async (axiosUrl) =>{
  //for(var i= 0; i<20;i++){
  //const recursiveResponse =  await axiosInstance.get(axiosUrl);
  //console.log(recursiveResponse.data);
  //}
  //}

  const selectingUserDynamically = (index, memberListInfo) => {
    console.log('function call: ', index);
    //MemberList.setSelectedUser( memberListInfo.MemberOrDependent[ index ] );
    ListUser(memberListInfo.MemberOrDependent[index], index);
    //setUserIndex( index );
    //setUserEmail( memberListInfo?.MemberOrDependent[ index ]?.UserEmail );
    //renderMemberManagementInfo(true, index);
  };
  //Preserving State

  const renderMemberManagementInfo = (
    preserveIndex = false,
    customIndex = 0,
  ) => {
    let selectedUser = null;

    selectedUser = MemberList.getSelectedUser();
    console.log('renderMemberManagementInfo: ', selectedUser);
    if (selectedUser != null) {
      const memberType =
        selectedUser.MemberType === 'Dependent' ? 'Dependent' : 'Employee';
      const memberOid = selectedUser.OID;
      console.log('CALLING FROM UserManagement Index: ', selectedUser.OID);
      //return <MemberDetailsInfo    {...props} pageSize={pageSize} activePage={activePage} isRegisterd={true} userEmail={userEmail} uoid={UserOid} userIndex={userIndex} updateCallback={memberUpdatedCallback} infoUpdated={memberUpdated} />;
      return (
        <AllMemberDetailsInfo
          {...props}
          pageSize={pageSize}
          activePage={activePage}
          isRegisterd={props.isRegisteredBtn}
          memberType={memberType}
          memberOid={memberOid}
          userIndex={preserveIndex ? customIndex : userIndex}
        />
      );
    }
  };

  //let eventlist;
  const ListUser = (event, index) => {
    console.log('function call: ', index);
    //eventlist = event;
    console.log(event, index, 'event');
    MemberList.setSelectedUser(event);
    setUserIndex(index);
    setUserEmail(event.UserEmail);
    renderMemberManagementInfo();
  };

  useEffect(() => {
    setActivePage(1);
  }, [props.searchText]);

  const pageSizeHandler = useCallback((pageSizeInfo) => {
    setActivePage(1);
    setPageSize(pageSizeInfo.value);
    setPreservePageSize(false);
    setPreserveSelectedIndex(false);
    //eslint-disable-next-line
  }, []);

  const PaginationTab = () => (
    <>
      {totalItemsCount > displayPaginationMininumCount ? (
        <CustomPagination
          siblingCount={0}
          className="memberManagePagination"
          pageSize={pageSize}
          currentPage={activePage}
          totalCount={totalItemsCount}
          onPageChange={(page) => {
            setActivePage(page);
            setPreservePageNumber(false);
            setPreserveSelectedIndex(false);
          }}
        />
      ) : null}
    </>
  );

  if (serverError)
    return <Navigate to="/admin/server-error" push={true}></Navigate>;

  return (
    <div>
      <div className="dashboard-navbar">
        {loadingPage && <AllMemberSkeleton />}
        <div>
          {!loadingPage &&
          !clientError &&
          !loadingMemberList &&
          totalItemsCount > displayPaginationMininumCount ? (
            <div className="table-footer">
              <CustomPaginationItemsDisplay
                pageSize={pageSize}
                setPageSize={pageSizeHandler}
                className="top-pagination"
                prefixMessage="Records per page"
                suffixMessage={`Showing ${itemsPerPageStart} - ${itemsPerPageEnd} of ${totalItemsCount} results`}
              />
              <PaginationTab />
            </div>
          ) : null}
        </div>
        {!loadingPage && !clientError && !loadingMemberList && (
          <Row>
            <Col>
              <Tab.Container id="left-tabs-example" defaultActiveKey="1">
                {totalItemsCount > 0 ? (
                  <Row className="mar-top-30">
                    {props.isAdditionalSearch && totalItemsCount == 1 ? null : (
                      <Col sm={4}>
                        {loadingMemberList && <AllMemberSkeleton />}
                        <div>
                          <div></div>
                          <div className="scroll">
                            <Nav
                              variant="pills"
                              className="flex-column usergrpTabs member-mgt nav nav-pills"
                            >
                              {memberSearchList ? (
                                <div>
                                  {memberSearchList.MemberOrDependent.map(
                                    (memberlist, index) => (
                                      <Nav.Item
                                        onClick={(e) =>
                                          ListUser(memberlist, index)
                                        }
                                        className="User-list-margin"
                                        key={`member-list-${index}`}
                                      >
                                        <Nav.Link
                                          className={
                                            userIndex === index
                                              ? 'active'
                                              : null
                                          }
                                        >
                                          <Row>
                                            <Col md={2}>
                                              <span className="mgt-user-icon-img">
                                                {memberlist.FirstName.charAt(
                                                  0,
                                                ) +
                                                  memberlist.LastName.charAt(0)}
                                              </span>
                                            </Col>
                                            <Col md={7} className="padding-0">
                                              <label>
                                                {memberlist.FirstName}{' '}
                                                {memberlist.LastName}
                                              </label>
                                            </Col>
                                            <Col>
                                              <p className="text-right">
                                                <span
                                                  className={
                                                    memberlist.Status ===
                                                    'Active'
                                                      ? 'user-active'
                                                      : 'inactive'
                                                  }
                                                >
                                                  {memberlist.Status}
                                                </span>
                                              </p>
                                            </Col>
                                          </Row>
                                          <Row className="usertabs-bottom">
                                            <Col>
                                              <p>
                                                User Type: {memberlist.UserType}
                                              </p>
                                            </Col>
                                            <Col>
                                              <p className="text-right">
                                                Created On:{' '}
                                                {memberlist.CreatedDate
                                                  ? memberlist.CreatedDate
                                                  : 'NA'}
                                              </p>
                                            </Col>
                                          </Row>
                                        </Nav.Link>
                                      </Nav.Item>
                                    ),
                                  )}
                                </div>
                              ) : (
                                <div>
                                  {memberListData.MemberOrDependent.map(
                                    (memberlist, index) => (
                                      <Nav.Item
                                        onClick={(e) =>
                                          ListUser(memberlist, index)
                                        }
                                        className="User-list-margin"
                                        key={`member-list-${index}`}
                                      >
                                        <Nav.Link
                                          className={
                                            userIndex === index
                                              ? 'active'
                                              : null
                                          }
                                        >
                                          <Row>
                                            <Col md={2} className="user-icon">
                                              <span className="mgt-user-icon-img ">
                                                {memberlist.FirstName.charAt(
                                                  0,
                                                ) +
                                                  memberlist.LastName.charAt(0)}
                                              </span>
                                            </Col>
                                            <Col
                                              md={7}
                                              className="padding-0 registered-username"
                                            >
                                              <label>
                                                {`${capitalizeFirstLetter(
                                                  memberlist.FirstName,
                                                )} ${capitalizeFirstLetter(
                                                  memberlist.LastName,
                                                )}`}
                                              </label>
                                            </Col>
                                          </Row>
                                          <Row className="usertabs-bottom">
                                            <Col>
                                              <p>
                                                User Type:{' '}
                                                {memberlist.MemberType}
                                              </p>
                                            </Col>
                                          </Row>
                                        </Nav.Link>
                                      </Nav.Item>
                                    ),
                                  )}
                                </div>
                              )}
                            </Nav>
                            <Row className="margin-10 usermanagement-pagination">
                              {totalItemsCount >
                              displayPaginationMininumCount ? (
                                <div className="memberManagePage">
                                  <CustomPaginationItemsDisplay
                                    prefixMessage="Records per page"
                                    pageSize={pageSize}
                                    setPageSize={pageSizeHandler}
                                  />
                                  <div>
                                    <PaginationTab />
                                  </div>
                                </div>
                              ) : null}
                            </Row>
                          </div>
                        </div>
                      </Col>
                    )}
                    <Col
                      sm={
                        props.isAdditionalSearch && totalItemsCount == 1
                          ? 12
                          : 8
                      }
                    >
                      {!loadingMemberList && renderMemberManagementInfo()}
                    </Col>
                  </Row>
                ) : (
                  !loadingMemberList && (
                    <Row>
                      <Col>
                        {props.isAdditionalSearch ? (
                          <CustomClientError
                            ErrorHeading={'No result(s) found!'}
                            ErrorMessage={
                              'Information you entered does not match our records. Enter the correct information and try again.'
                            }
                          />
                        ) : (
                          <CustomClientError
                            ErrorHeading="No Members found!"
                            ErrorMessage="We are unable to render member list for given search. "
                            NoDataFound={true}
                          />
                        )}
                      </Col>
                    </Row>
                  )
                )}
              </Tab.Container>
            </Col>
          </Row>
        )}
        {!loadingPage && isAPIFailed ? (
          <Row>
            <Col>
              {isNotFound ? (
                props.isAdditionalSearch ? (
                  <CustomClientError
                    ErrorHeading={'No result(s) found!'}
                    ErrorMessage={
                      'Information you entered does not match our records. Enter the correct information and try again.'
                    }
                  />
                ) : (
                  <CustomClientError
                    ErrorHeading={'No Members found!'}
                    ErrorMessage={
                      'We are unable to render member list for given search.'
                    }
                  />
                )
              ) : (
                <CustomClientError
                  ErrorHeading="Something went wrong with request!"
                  ErrorMessage="Please try again."
                />
              )}
            </Col>
          </Row>
        ) : (
          <></>
        )}
      </div>
    </div>
  );
};

export default AllMember;
